import React from "react";
import CustomTable from "../../../../components/Table/CustomTable";
import ToggleSwitch from "../../../../components/Settings/suppliers/ToggleSwitch";
import updateHotelSettings from "../../../../controllers/hotelSettings/updateHotelSettings";
import { enqueueSnackbar } from "notistack";

export default function ManageEsimSuppliers({ data, loading, reload }) {
  async function handleEnable(newStatus, name) {
    let enabledEsimSuppliers = data
      ?.filter((obj) => obj?.status && obj?.name !== name)
      ?.map((obj) => obj?.name);
    if (newStatus) enabledEsimSuppliers.push(name);

    const res = await updateHotelSettings({
      enabledEsimSuppliers,
    });
    if (res.return) {
      enqueueSnackbar(name + " supplier updated", { variant: "success" });
    } else enqueueSnackbar(res.msg, { variant: "error" });
    reload && reload();
  }

  const columns = [
    {
      field: "name",
      headerName: "Supplier",
      flex: 1,
      renderCell: (params) => (
        <div className="flex items-center gap-2 capitalize">{params.value}</div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => (
        <div>
          <ToggleSwitch
            toggleValue={params.value}
            callback={(val) => handleEnable(val, params?.row?.name)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="bg-secondary">
      <CustomTable rows={data} columns={columns} loading={loading} />
    </div>
  );
}
